import { render, staticRenderFns } from "./reveal-faq.vue?vue&type=template&id=32f64112&scoped=true&"
import script from "./reveal-faq.vue?vue&type=script&lang=js&"
export * from "./reveal-faq.vue?vue&type=script&lang=js&"
import style0 from "./reveal-faq.vue?vue&type=style&index=0&id=32f64112&scoped=true&lang=scss&"
import style1 from "./reveal-faq.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f64112",
  null
  
)

export default component.exports